import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";


export const getQuestionbyChapterSuccess = (data) => {
  return {
    type: actionTypes.GET_QUESTION_BY_CHAPTER,
    payload: {
      questionByChapter: data.Data,
    },
  };
};

export const getQuestionbyChapter = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/GetQuestionbyChapter`, data)
    .then((response) => {
      if (response) {
        dispatch(getQuestionbyChapterSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
